import axios from 'axios';

const state = {
  assets: [],
  poolSize: 100,
};

export const axiosInstance = axios.create();

/* eslint-disable no-param-reassign, no-shadow */
const mutations = {
  updateAsset(state, updated) {
    const existingIndex = state.assets.findIndex(asset => asset.url === updated.url);
    if (existingIndex === -1) return state.assets.push(updated);
    return state.assets.splice(existingIndex, 1, updated);
  },
  removeAsset(state, asset) {
    const index = state.assets.indexOf(asset);
    if (index !== -1) state.assets.splice(index, 1);
  },
};

const actions = {
  load: ({ state, commit, dispatch }, { url, keep = false } = {}) => {
    if (!url) return null;

    const existing = state.assets.find(asset => asset.url === url);
    if (existing) return existing;

    const asset = { url, keep };
    asset.request = axiosInstance({ method: 'get', url, responseType: 'blob' })
      .then(({ data }) => {
        asset.blob = URL.createObjectURL(data);
        commit('updateAsset', asset);
      })
      // eslint-disable-next-line no-console
      .catch(() => {
        asset.blob = url;
      });
    commit('updateAsset', asset);
    dispatch('compact');

    return asset;
  },
  compact: ({ state, commit }) => {
    const unprotected = state.assets.filter(asset => !asset.keep);
    if (unprotected.length <= state.poolSize) return;

    const assetsToRemove = unprotected.slice(0, unprotected.length - state.poolSize);
    assetsToRemove.forEach((asset) => {
      if (asset.blob) URL.revokeObjectURL(asset.blob);
      commit('removeAsset', asset);
    });
  },
};

const getters = {
  get: state => (url) => {
    const asset = url && state.assets.find(asset => asset.url === url);
    return asset && asset.blob;
  },
};
/* eslint-enable no-param-reassign, no-shadow, no-unused-expressions */

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
